const useValidadorTipoCurso = (materiasSeleccionadas) => {
    if (!materiasSeleccionadas || !materiasSeleccionadas.length) return [];

    let tipoCursos = [];
    materiasSeleccionadas.filter(x => !!x.tipocurso).forEach(x => {
        let item = tipoCursos.filter(y => y.tipocurso === x.tipocurso)[0];
        if (!item) {
            item = { tipocurso: x.tipocurso, maximotipocurso: x.maximotipocurso, total: 0 };
            tipoCursos.push(item)
        }
        item.total++;
    });

    const conflictosTipoCurso = tipoCursos.filter(x => {
        if (x.maximotipocurso === -1) return true; //no debe poder seleccionarse
        if (x.maximotipocurso === 0) return false; //puede seleccionar las que quiera
        if (x.total > x.maximotipocurso) return true; //solo puede seleccionar hasta maximotipocurso
        return false;
    });

    //Asignar indicador en la materias con conflicto de tipocurso
    materiasSeleccionadas.forEach(x => x.hasConflictoTipoCurso = false);
    conflictosTipoCurso.forEach(conflicto => {
        materiasSeleccionadas
            .filter(x => x.tipocurso === conflicto.tipocurso)
            .forEach(x => x.hasConflictoTipoCurso = true);
    });

    return { conflictosTipoCurso, tipoCursos };
};

export default useValidadorTipoCurso;